import { render, staticRenderFns } from "./VInternalAquisitionRow.vue?vue&type=template&id=ab4e4634"
import script from "./VInternalAquisitionRow.vue?vue&type=script&lang=js"
export * from "./VInternalAquisitionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports